module.exports = __webpack_public_path__ + "static/media/computer.1e8e3ebb.png";